import React from "react";
import InvoicesView from "./components/InvoicesView";
import {Biscuit} from "../../../utils";

export const InvoicesPage = props => {
    let _view = typeof props.view === 'undefined' || props.view === null ? 'index' : props.view;
    let indexView = Biscuit.get('user.is_superuser') === 'true'?'invoices':'';
    return (
        <>
            {(_view === 'invoices' || (_view === 'index' && indexView === 'invoices')) &&
                <InvoicesView
                    name={"Invoices"}
                    dispatch={props.dispatch}
                    params={props.params}
                    returnPath={props.returnPath}
                    action={props.action}
                />
            }
        </>
    );
}